module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"dialogHeader":"Nuovo appuntamento","createBooking":"Crea appuntamento","bookingCreated":"Appuntamento Creato!","cannotCreateBooking":"Impossibile creare l\u0027appuntamento"}}')
  delete Component.options._Ctor
}
